var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.6866C0.303596 14.2784 0.582103 13.1328 0.83552 12.2497C1.28656 10.6781 1.94298 8.90729 2.80477 6.93736C2.92437 6.66396 3.19596 6.48709 3.49616 6.48709L7.84539 5.92035L6.98417 6.26452L7.67528 7.2829C7.73771 7.37489 7.76122 7.48756 7.74074 7.59661L6.772 12.7556C6.76492 12.7933 6.77363 12.8322 6.79612 12.8634L7.94181 14.4527C7.95087 14.4652 7.96195 14.4762 7.97461 14.4852C8.03834 14.5305 8.12699 14.516 8.17261 14.4527L9.31831 12.8634C9.34079 12.8322 9.3495 12.7933 9.34242 12.7556L8.37368 7.59661C8.3532 7.48756 8.37671 7.37489 8.43914 7.2829L9.13025 6.26452L8.26903 5.92035L12.6183 6.48709C12.9185 6.48709 13.19 6.66396 13.3097 6.93736C14.1714 8.90729 14.8279 10.6781 15.2789 12.2497C15.5323 13.1328 15.8108 14.2784 16.1144 15.6866H13.3568C12.6835 13.5826 12.2388 12.3654 12.0227 12.0348C11.5117 11.2532 11.384 14.7544 11.384 15.3432C11.384 15.4132 11.3977 15.5298 11.4223 15.6866H4.69211C4.71675 15.5298 4.73038 15.4132 4.73038 15.3432C4.73038 14.7544 4.60272 11.2532 4.09172 12.0348C3.87561 12.3654 3.43091 13.5826 2.75762 15.6866H0ZM8.05721 5.23915C6.60011 5.23915 5.4189 4.06633 5.4189 2.61958C5.4189 1.17282 6.60011 0 8.05721 0C9.51431 0 10.6955 1.17282 10.6955 2.61958C10.6955 4.06633 9.51431 5.23915 8.05721 5.23915Z",
    fill: "#0005E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserType2);
export default __webpack_public_path__ + "static/media/UserType2.2367fb48b5c4a5a787e0618c10f02bfe.svg";
export { ForwardRef as ReactComponent };